/**
 * @generated SignedSource<<c485b4d19549a454c4f10b14c03dc796>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DashboardBlockContentMode = "full" | "preview" | "%future added value";
export type DashboardBlockCurriculumView = "card" | "list" | "%future added value";
export type DashboardBlockEventsView = "card" | "list" | "%future added value";
export type DashboardBlockFeaturedItemConfigKind = "collection" | "event" | "experience" | "membership" | "%future added value";
export type DashboardBlockFeedView = "card" | "list" | "%future added value";
export type DashboardBlockHeroMode = "color" | "image" | "no_fill" | "%future added value";
export type DashboardBlockKind = "banner" | "channels" | "collection_folder" | "community_welcome_hero" | "content" | "continue_your_products" | "curriculum" | "experience_details" | "featured_items" | "feed" | "hero" | "leaderboard" | "members_list" | "memberships" | "pathway_sequence" | "product_admin" | "recently_viewed" | "rich_text" | "upcoming_events" | "welcome_banner" | "%future added value";
export type DashboardBlockLeaderboardLookbackWindow = "last_30_days" | "last_365_days" | "last_7_days" | "last_90_days" | "last_month" | "last_week" | "last_year" | "this_month" | "this_week" | "this_year" | "%future added value";
export type DashboardBlockLeaderboardView = "card" | "list" | "%future added value";
export type DashboardBlockMembersListMemberType = "admin_only" | "all" | "member_only" | "%future added value";
export type DashboardBlockPosition = "main" | "side" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EditDashboardBlockFormFragment$data = {
  readonly __typename: string;
  readonly askAi?: boolean;
  readonly channelsTitle?: string;
  readonly color?: string | null;
  readonly contentId?: string;
  readonly contentMode?: DashboardBlockContentMode;
  readonly contentUsages?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly contentId: string;
        readonly id: string;
      };
    }>;
  } | null;
  readonly count?: number;
  readonly cover?: string | null;
  readonly ctaText?: string | null;
  readonly ctaUrl?: string | null;
  readonly curriculumTitle?: string;
  readonly curriculumView?: DashboardBlockCurriculumView;
  readonly dashboardId: string;
  readonly description?: string | null;
  readonly eventType?: string;
  readonly eventsView?: DashboardBlockEventsView;
  readonly featuredKind?: DashboardBlockFeaturedItemConfigKind;
  readonly featuredProducts?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }>;
  };
  readonly feedShowCover?: boolean;
  readonly feedTitle?: string;
  readonly feedView?: DashboardBlockFeedView;
  readonly hasCtaButton?: boolean | null;
  readonly header?: string | null;
  readonly headerWithMacrosReplaced?: string | null;
  readonly heroMode?: DashboardBlockHeroMode;
  readonly hideAfter?: string | null;
  readonly id: string;
  readonly kind: DashboardBlockKind;
  readonly leaderboardCount?: number;
  readonly leaderboardDescription?: string;
  readonly leaderboardLookbackWindow?: DashboardBlockLeaderboardLookbackWindow;
  readonly leaderboardTitle?: string;
  readonly leaderboardView?: DashboardBlockLeaderboardView;
  readonly memberType?: DashboardBlockMembersListMemberType;
  readonly membersListCount?: number;
  readonly position: DashboardBlockPosition;
  readonly richEditorContent?: string | null;
  readonly richEditorDescription?: string;
  readonly richTextBlockTitle?: string | null;
  readonly showAttendance?: boolean;
  readonly showAvailability?: boolean;
  readonly showCountdown?: boolean;
  readonly showCover?: boolean;
  readonly showDates?: boolean;
  readonly showMembers?: boolean;
  readonly showOnMobile: boolean;
  readonly showProgress?: boolean;
  readonly showWelcomeText?: boolean;
  readonly subText?: string | null;
  readonly subtitle?: string;
  readonly textColor?: string | null;
  readonly title?: string;
  readonly " $fragmentType": "EditDashboardBlockFormFragment";
};
export type EditDashboardBlockFormFragment$key = {
  readonly " $data"?: EditDashboardBlockFormFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditDashboardBlockFormFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtitle",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cover",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showDates",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCountdown",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCover",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditDashboardBlockFormFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showOnMobile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dashboardId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "richEditorDescription",
          "storageKey": null
        },
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hideAfter",
          "storageKey": null
        }
      ],
      "type": "WelcomeBannerDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "richTextBlockTitle",
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "richEditorContent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasCtaButton",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaText",
          "storageKey": null
        }
      ],
      "type": "RichTextDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showMembers",
          "storageKey": null
        },
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showProgress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showAttendance",
          "storageKey": null
        }
      ],
      "type": "ExperienceDetailsDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "contentMode",
          "args": null,
          "kind": "ScalarField",
          "name": "mode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeConnection",
          "kind": "LinkedField",
          "name": "contentUsages",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsageNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContentUsage",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v6/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "ContentDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v6/*: any*/)
      ],
      "type": "CollectionFolderDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "featuredKind",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductNodeConnection",
          "kind": "LinkedField",
          "name": "featuredProducts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Product",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "FeaturedItemsDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "heroMode",
          "args": null,
          "kind": "ScalarField",
          "name": "mode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headerWithMacrosReplaced",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subText",
          "storageKey": null
        },
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "askAi",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showWelcomeText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textColor",
          "storageKey": null
        }
      ],
      "type": "HeroDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "leaderboardCount",
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": "leaderboardTitle",
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": "leaderboardDescription",
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": "leaderboardLookbackWindow",
          "args": null,
          "kind": "ScalarField",
          "name": "lookbackWindow",
          "storageKey": null
        },
        {
          "alias": "leaderboardView",
          "args": null,
          "kind": "ScalarField",
          "name": "view",
          "storageKey": null
        }
      ],
      "type": "LeaderboardDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "membersListCount",
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "memberType",
          "storageKey": null
        }
      ],
      "type": "MembersListDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventType",
          "storageKey": null
        },
        (v7/*: any*/),
        {
          "alias": "eventsView",
          "args": null,
          "kind": "ScalarField",
          "name": "view",
          "storageKey": null
        }
      ],
      "type": "UpcomingEventsDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "feedTitle",
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": "feedView",
          "args": null,
          "kind": "ScalarField",
          "name": "view",
          "storageKey": null
        },
        {
          "alias": "feedShowCover",
          "args": null,
          "kind": "ScalarField",
          "name": "showCover",
          "storageKey": null
        }
      ],
      "type": "FeedDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "curriculumTitle",
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": "curriculumView",
          "args": null,
          "kind": "ScalarField",
          "name": "view",
          "storageKey": null
        }
      ],
      "type": "CurriculumDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "channelsTitle",
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "type": "ChannelsDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v7/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showAvailability",
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "type": "BannerDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "type": "CommunityWelcomeHeroDashboardBlock",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/)
      ],
      "type": "ContinueYourProductsDashboardBlock",
      "abstractKey": null
    }
  ],
  "type": "DashboardBlock",
  "abstractKey": "__isDashboardBlock"
};
})();

(node as any).hash = "150dd5f54aea27f0f781f6f664b891e0";

export default node;
